import { ReactComponent as XlsxFileIcon } from "../assets/images/file-types/Type=XSLX.svg"
import { ReactComponent as XlsFileIcon } from "../assets/images/file-types/Type=XLS.svg"
import { ReactComponent as CsvFileIcon } from "../assets/images/file-types/Type=CSV.svg"
import { ReactComponent as PdfFileIcon } from "../assets/images/file-types/Type=PDF.svg"

const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"]

const getExtension = (name = "") => {
  const dotIndex = name.lastIndexOf(".")
  return dotIndex >= 0 ? name.slice(dotIndex + 1).toLowerCase() : ""
}

export const isImageFile = (name, mimeType) => {
  if (mimeType && mimeType.startsWith("image/")) return true
  return IMAGE_EXTENSIONS.includes(getExtension(name))
}

export const getFileTypeIcon = (name) => {
  switch (getExtension(name)) {
    case "xlsx":
      return <XlsxFileIcon />
    case "xls":
      return <XlsFileIcon />
    case "csv":
      return <CsvFileIcon />
    case "pdf":
    default:
      return <PdfFileIcon />
  }
}
